import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getAction, deleteAction } from '@api/manage';
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import { GetSiteIdMixin } from '@/mixins/GetSiteIdMixin';
import iotKeyAdd from "./iotKeyAdd.vue";
export default {
  name: 'SelectSiteListModal',
  mixins: [JeecgListMixin, GetSiteIdMixin],
  components: {
    iotKeyAdd: iotKeyAdd
  },
  data: function data() {
    return {
      title: '选择站点',
      pagePath: '/site/iot/key',
      queryParam: {},
      // 对话框里得表头
      IotKeyColumns: [{
        dataIndex: 'name',
        colName: 'name',
        title: '名称',
        align: 'center'
      }, {
        dataIndex: 'vendorInfo',
        colName: 'vendorInfo',
        title: '密钥',
        align: 'center'
      }, {
        dataIndex: 'address',
        colName: 'address',
        title: '接口地址',
        align: 'center'
      }, {
        dataIndex: 'vendor_dictText',
        colName: 'vendor_dictText',
        title: '供应商',
        align: 'center'
      }, {
        title: '操作',
        dataIndex: 'action',
        align: 'center',
        width: 120,
        scopedSlots: {
          customRender: 'action'
        }
      }],
      url: {
        queryIotKey: '/site/iot/key'
      },
      dataSource: [],
      ipagination: {
        current: 1,
        pageSize: 5,
        pageSizeOptions: ['5', '10', '20'],
        showTotal: function showTotal(total, range) {
          return range[0] + '-' + range[1] + ' 共' + total + '条';
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0
      },
      isorter: {
        column: 'create_time',
        order: 'desc'
      },
      toggleSearchStatus: false,
      visible: false,
      IotKeyList: [],
      companyId: ''
    };
  },
  methods: {
    getIotKeyList: function getIotKeyList(name) {
      var _this = this;

      getAction(this.url.queryIotKey, {
        name: name
      }).then(function (res) {
        if (res.success) {
          _this.IotKeyList = res.result.records;
          _this.ipagination.total = res.result.total;
        }
      });
    },
    searchReset: function searchReset() {
      this.queryParam = {};
      this.getIotKeyList();
    },
    searchKey: function searchKey(name) {
      console.log('name', name);
      this.getIotKeyList(name);
    },
    handleCancel: function handleCancel() {
      this.visible = false;
      this.searchReset();
    },
    handleKeyAdd: function handleKeyAdd() {
      this.$refs.iotKeyAddRef.add();
    },
    handleEdit: function handleEdit(record) {
      this.$refs.iotKeyAddRef.edit(record);
    },
    handleTableChange: function handleTableChange(pagination, filters, sorter) {
      //TODO 筛选
      if (Object.keys(sorter).length > 0) {
        this.isorter.column = sorter.field;
        this.isorter.order = 'ascend' == sorter.order ? 'asc' : 'desc';
      }

      this.ipagination = pagination;
      this.getIotKeyList();
    },
    handleDelete: function handleDelete(id) {
      var _this2 = this;

      deleteAction(this.pagePath, {
        id: id
      }, {}).then(function (res) {
        if (res.success) {
          _this2.$notification.success({
            message: res.message
          });

          _this2.getIotKeyList();
        } else {
          _this2.$notification.warning({
            message: res.message
          });
        }
      });
    }
  }
};